import useOrganization from 'hooks/useOrganization';
import useLoginStore from 'store/loginStore';
import useFetchData from './useFetchData';

export default function useFetchDataWithOrg(uri) {

    const { organization } = useOrganization();
    const ORGANIZATION_ID = organization?.organizationId;
    const currentRole = useLoginStore(s => s.getCurrentRole)();
    const roleParam = currentRole ? `&role=${currentRole}` : '';
    return useFetchData(uri && `${uri}&organizationId=${ORGANIZATION_ID}${roleParam}`);
}
